import { atom, useAtom } from 'jotai';
import { useEffect } from 'react';
import { Utils } from '@/shared/Utils';

export const isSupportedDeviceAtom = atom<boolean>(true);

export const useIsSupportedDevice = () => {
    const [isSupportedDevice, setIsSupportedDevice] = useAtom(
        isSupportedDeviceAtom,
    );

    useEffect(() => {
        if (isSupportedDevice !== null) return; // already checked

        const checkIsSupported = async () => {
            const isEmbedded = (window as any).isEmbedded === true;
            const supported = isEmbedded
                ? true
                : await Utils.isSupportedDevice();
            setIsSupportedDevice(supported);
        };

        void checkIsSupported();
    }, [isSupportedDevice, setIsSupportedDevice]);

    return isSupportedDevice;
};
